export const density = {
  standard: {
    dataGrid: { rowHeight: 42, headerHeight: 38, fontSize: 13 },
    inputSize: 'medium',
    buttonSize: 'medium',
  },
  compact: {
    dataGrid: { rowHeight: 42, headerHeight: 38, fontSize: 13 },
    inputSize: 'small',
    buttonSize: 'small',
  },
} as const;

export type DensityMode = keyof typeof density;
